// extracted by mini-css-extract-plugin
module.exports = {"box":"box___1Y_zV"};